import React, { useState } from 'react';
import Layout from "@/locales/en/layout/Layout";
import CustomTitle from "@/components/custom_title";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import styled, { keyframes } from 'styled-components';
import parse from 'html-react-parser';

//1
import img1_1 from "./img/1.1.jpg";
import img1_2 from "./img/1.2.jpg";
import img1_3 from "./img/1.3.jpg";
import img1_4 from "./img/1.4.jpg";
import img1_5 from "./img/1.5.jpg";
import img1_6 from "./img/1.6.jpg";
//2
import img2_1 from "./img/2.1.jpg";
import img2_2 from "./img/2.2.jpg";
import img2_3 from "./img/2.3.jpg";
//3
import img3_1 from "./img/3.1.jpg";
import img3_2 from "./img/3.2.jpg";
import img3_3 from "./img/3.3.jpg";
import img3_4 from "./img/3.4.jpg";
import img3_5 from "./img/3.5.jpg";
import img3_6 from "./img/3.6.jpg";
import img3_7 from "./img/3.7.jpg";
import img3_8 from "./img/3.8.jpg";
import img3_9 from "./img/3.9.jpg";
//4
import img4_1 from "./img/4.1.jpg";
import img4_2 from "./img/4.2.jpg";
import img4_3 from "./img/4.3.jpg";
import img4_4 from "./img/4.4.jpg";
import img4_5 from "./img/4.5.jpg";
import img4_6 from "./img/4.6.jpg";
//5
import img5_1 from "./img/5.1.jpg";
import img5_2 from "./img/5.2.jpg";
import img5_3 from "./img/5.3.jpg";
import img5_4 from "./img/5.4.jpg";
import img5_5 from "./img/5.5.jpg";
import img5_6 from "./img/5.6.jpg";
//6
import img6_1 from "./img/6.1.jpg";
import img6_2 from "./img/6.2.jpg";
import img6_3 from "./img/6.3.jpg";
import img6_4 from "./img/6.4.jpg";
//7
import img7_1 from "./img/7.1.jpg";
import img7_2 from "./img/7.2.jpg";
import img7_3 from "./img/7.3.jpg";
import img7_4 from "./img/7.4.jpg";
import img7_5 from "./img/7.5.jpg";
import img7_6 from "./img/7.6.jpg";
import img7_7 from "./img/7.7.jpg";
import img7_8 from "./img/7.8.jpg";
import img7_9 from "./img/7.9.jpg";
import img7_10 from "./img/7.10.jpg";
//8
import img8_1 from "./img/8.1.jpg";
import img8_2 from "./img/8.2.jpg";
import img8_3 from "./img/8.3.jpg";
import img8_4 from "./img/8.4.jpg";
import img8_5 from "./img/8.5.jpg";
import img8_6 from "./img/8.6.jpg";
import img8_7 from "./img/8.7.jpg";
import img8_8 from "./img/8.8.jpg";
import img8_9 from "./img/8.9.jpg";

/* ── Animations ─────────────────────────────────────────── */
const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
`;

/* ── Page wrapper ────────────────────────────────────────── */
const PageWrapper = styled.div`
  background: linear-gradient(160deg, #f0fdf4 0%, #ecfdf5 40%, #f8fafc 100%);
  min-height: 100vh;
  padding-bottom: 60px;
`;

/* ── Grid ────────────────────────────────────────────────── */
const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
  padding: 32px 0 8px;

  @media (max-width: 1024px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 600px)  { grid-template-columns: 1fr; }
`;

/* ── Card ────────────────────────────────────────────────── */
const CardWrapper = styled.div`
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 24px rgba(21, 82, 61, 0.08), 0 1px 6px rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
  transition: transform 0.28s ease, box-shadow 0.28s ease;
  animation: ${fadeInUp} 0.5s ease both;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 16px 40px rgba(21, 82, 61, 0.16), 0 4px 12px rgba(0,0,0,0.07);
  }
`;

/* ── Gallery wrap ────────────────────────────────────────── */
const GalleryWrap = styled.div`
  .image-gallery-slide img {
    max-height: 240px;
    width: 100%;
    object-fit: cover;
  }
  .image-gallery-thumbnail img { height: 52px; object-fit: cover; }
`;

/* ── Card body ───────────────────────────────────────────── */
const CardBody = styled.div`
  padding: 18px 20px 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const TagLine = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

const CardTitle = styled.h3`
  font-size: 14px;
  font-weight: 700;
  color: #134e3a;
  line-height: 1.45;
  margin: 0;
`;

/* ── Collapse button ─────────────────────────────────────── */
const CollapseBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #15523d, #1e7a58);
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 8px 14px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  letter-spacing: 0.3px;
  transition: all 0.22s ease;
  width: fit-content;
  margin-top: auto;

  .chevron {
    transition: transform 0.3s;
    display: flex;
    align-items: center;
  }

  &.open .chevron { transform: rotate(180deg); }

  &:hover {
    background: linear-gradient(135deg, #0f3d2c, #15523d);
    box-shadow: 0 4px 14px rgba(21, 82, 61, 0.35);
  }
`;

/* ── Collapse body ───────────────────────────────────────── */
const CollapseBody = styled.div`
  overflow: hidden;
  max-height: ${({ open }) => (open ? '2000px' : '0')};
  transition: max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;
  opacity: ${({ open }) => (open ? 1 : 0)};

  .collapse-inner {
    padding: 14px 0 4px;
    font-size: 13px;
    line-height: 1.7;
    color: #374151;

    p { margin-bottom: 8px; }
    strong { color: #15523d; }
    blockquote {
      border-left: 3px solid #15523d;
      padding-left: 12px;
      margin: 10px 0;
      color: #15523d;
      font-weight: 600;
    }
  }
`;

/* ── Video card ──────────────────────────────────────────── */
const VideoCardWrapper = styled(CardWrapper)`
  .video-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: #dcfce7;
    color: #15803d;
    border-radius: 8px;
    padding: 4px 10px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 4px;
  }

  iframe {
    width: 100%;
    height: 240px;
    display: block;
  }
`;

/* ── Leaf icon ───────────────────────────────────────────── */
function LeafIcon() {
  return (
    <svg style={{ flexShrink: 0, marginTop: 2 }} width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M17 8C8 10 5.9 16.17 3.82 21.34L5.71 22l1-2.3A4.49 4.49 0 008 20C19 20 22 3 22 3c-1 2-8 2-10 5" fill="#15803d"/>
      <path d="M2 21.5s2-6.5 9-8" stroke="#15803d" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}

/* ── Chevron icon ────────────────────────────────────────── */
function ChevronIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="6 9 12 15 18 9"/>
    </svg>
  );
}

/* ── Single green card ───────────────────────────────────── */
function GreenCard({ item }) {
  const [open, setOpen] = useState(false);

  return (
    <CardWrapper>
      <GalleryWrap>
        <ImageGallery
          items={item.img}
          showPlayButton={false}
          showFullscreenButton
          lazyLoad
        />
      </GalleryWrap>
      <CardBody>
        <TagLine>
          <LeafIcon />
          <CardTitle>{item.title}</CardTitle>
        </TagLine>

        <CollapseBtn
          className={open ? 'open' : ''}
          onClick={() => setOpen(v => !v)}
          aria-expanded={open}
        >
          {open ? 'Yopish' : "Batafsil o'qish"}
          <span className="chevron"><ChevronIcon /></span>
        </CollapseBtn>

        <CollapseBody open={open}>
          <div className="collapse-inner">
            {parse(item.text)}
          </div>
        </CollapseBody>
      </CardBody>
    </CardWrapper>
  );
}

/* ── Main page ───────────────────────────────────────────── */
function GreenUniversitet() {
  document.title = "Yashil universitet";

  const dateAllGreen = [
    {
      title: "TDTUda \u201cYashil makon\u201d umummilliy loyihasi doirasida ko\u2019chat ekish aksiyasi o\u2019tkazildi",
      text: "<p>\uD83C\uDF3F Islom Karimov nomidagi Toshkent davlat texnika universitetida mamlakatimizda ekologik vaziyatni yaxshilash, yashil maydonlarni kengaytirishga hissa qo&lsquo;shish maqsadida &ldquo;Yashil makon&rdquo; umummilliy loyihasi doirasida ko&lsquo;chat ekish aksiyasi o&lsquo;tkazildi.&nbsp;</p><p>\uD83C\uDF3F Davlatimiz rahbari tomonidan ilgari surilgan &ldquo;Yashil makon&rdquo; umummilliy loyihasi doirasida tashkil etilgan aksiyada universitet rahbariyati, professor-o&lsquo;qituvchilar, fakultet talabalari, ishchi-xodimlar, tyutorlar hamda talaba-yoshlar ishtirok etdi.</p>",
      img: [
        { original: img1_1, thumbnail: img1_1 },
        { original: img1_2, thumbnail: img1_2 },
        { original: img1_3, thumbnail: img1_3 },
        { original: img1_4, thumbnail: img1_4 },
        { original: img1_5, thumbnail: img1_5 },
        { original: img1_6, thumbnail: img1_6 },
      ],
    },
    {
      title: "TDTU rektori akademik Sadritdin Turabdjanov \"Yashil makon\" loyihasida faol ishtirok etdi",
      text: "<p>\u2705 \"Yashil makon\" umummilliy loyihasi doirasida oliy ta\u02BFlim muassasalarida \"Ziyolilar bog&lsquo;\"lari tashkil etilishi munosabati bilan Jizzax politexnika institutida ko&lsquo;chat ekish marafoniga start berildi.<br>\u2705 Oliy ta\u02BFlim, fan va innovatsiyalar vazirligi tashabbusi bilan tashkil etilgan ushbu tadbirda Jizzax viloyati hokimi o&lsquo;rinbosari, Oliy ta\u02BFlim vaziri Qo&lsquo;ng&lsquo;irotboy Sharipov boshchiligidagi vazirlik mutasaddilari, hududiy boshqarmalar va ko\u02BBplab oliy ta\u02BFlim muassasalari rektorlari ishtirok etdi.<br>\u2705 Tadbirda TDTU rektori, akademik Sadritdin Turabdjanov ham faol tashabbus ko\u02BBrsatdi.</p>",
      img: [
        { original: img2_1, thumbnail: img2_1 },
        { original: img2_2, thumbnail: img2_2 },
        { original: img2_3, thumbnail: img2_3 },
      ],
    },
    {
      title: "\u201cToza muhit \u2013 sog\u2019lom hayot garovi!\u201d aksiyasi bo\u2019lib o\u2019tdi",
      text: "<p>\uD83D\uDD38 Bugun, 18-oktyabr kuni <strong>Toshkent davlat texnika universiteti Neft va gaz fakultetida birinchilardan bo\u02BBlib &ldquo;Tozalik va ozodalik oyligi&rdquo;</strong> doirasida <strong>&ldquo;Toza muhit &ndash; sog&lsquo;lom hayot garovi!&rdquo;</strong> shiori ostida keng ko\u02BBlamli aksiyaga start berildi.<br><br>\uD83D\uDD38 Mazkur tadbirda <strong>fakultet jamoasi</strong> hamda <strong>talaba-yoshlar</strong> faol ishtirok etishdi.</p><blockquote><strong>Aksiya davomida:</strong></blockquote><p><strong>\uD83D\uDD39 o&lsquo;quv binolari atrofi va xiyobonlarda obodonlashtirish ishlari olib borildi,<br>\uD83D\uDD39 hududlar chiqindi va keraksiz buyumlardan tozalandi.</strong></p>",
      img: [
        { original: img4_1, thumbnail: img4_1 },
        { original: img4_2, thumbnail: img4_2 },
        { original: img4_3, thumbnail: img4_3 },
        { original: img4_4, thumbnail: img4_4 },
        { original: img4_5, thumbnail: img4_5 },
        { original: img4_6, thumbnail: img4_6 },
      ],
    },
    {
      title: "Toza muhit \u2013 sog\u2019lom hayot garovi!",
      text: "<p>\uD83D\uDD3A Islom Karimov nomidagi <strong>TDTU Neft va gaz </strong>fakulteti <strong>\"Ekologiya va atrof-muhit muh\u0151fazasi\"</strong> kafedrasi professor-o\u2019qituvchilari tomonidan <strong>&ldquo;Tozalik va ozodalik oyligi&rdquo;</strong> doirasida <strong>&ldquo;Toza muhit &ndash; sog&lsquo;lom hayot garovi!&rdquo;</strong> shiori ostida keng ko\u02BBlamli aksiya bo\u2019lib o\u2019tdi.</p><blockquote><strong>Aksiya davomida:</strong></blockquote><p><strong>\uD83D\uDD39 o&lsquo;quv binolari atrofi va xiyobonlarda obodonlashtirish ishlari olib borildi,<br>\uD83D\uDD39 hududlar chiqindi va keraksiz buyumlardan tozalandi.</strong><br><br>\uD83D\uDD38 Bunday aksiyalar nafaqat hududni tozalash, balki <strong>yoshlarda ekologik madaniyat</strong> va <strong>mas&rsquo;uliyat hissini oshirishga</strong> xizmat qiladi.</p>",
      img: [
        { original: img5_1, thumbnail: img5_1 },
        { original: img5_2, thumbnail: img5_2 },
        { original: img5_3, thumbnail: img5_3 },
        { original: img5_4, thumbnail: img5_4 },
        { original: img5_5, thumbnail: img5_5 },
        { original: img5_6, thumbnail: img5_6 },
      ],
    },
    {
      title: "\u201cYashil kelajak uchun birlashamiz!\u201d aksiyasi bo\u2019lib o\u2019tdi",
      text: "<p>\uD83D\uDD38 <strong>TDTU Neft va gaz fakultetida &ldquo;Tozalik va ozodalik oyligi&rdquo;</strong> doirasida <strong>&ldquo;Yashil kelajak uchun birlashamiz!&rdquo;</strong> shiori ostida aksiyaga start berildi.<br><br><strong>Aksiya davomida:</strong><br><strong>\uD83D\uDD39 o&lsquo;quv binolari atrofi va xiyobonlarda obodonlashtirish ishlari olib borildi,<br>\uD83D\uDD39 hududlar chiqindi va keraksiz buyumlardan tozalandi.</strong></p>",
      img: [
        { original: img6_1, thumbnail: img6_1 },
        { original: img6_2, thumbnail: img6_2 },
        { original: img6_3, thumbnail: img6_3 },
        { original: img6_4, thumbnail: img6_4 },
      ],
    },
    {
      title: "Ekologik mas\u2019uliyat \u2013 barchamizning burchimiz",
      text: "<p>\uD83D\uDD38 <strong>TDTU Neft va gaz fakultetida &ldquo;Tozalik va ozodalik oyligi&rdquo;</strong> doirasida turli aksiyalar davom etmoqda. Bugalgi aksiya <strong>&ldquo;Ekologik mas&rsquo;uliyat &ndash; barchamizning burchimiz&rdquo;</strong> shiori ostida bo\u02BBlib o\u02BBtdi.<br><br><strong>Aksiya davomida:</strong><br><strong>\uD83D\uDFE2 talabalar fakultet hududida tozalash ishlari olib borishdi,<br>\uD83D\uDFE2 chiqindilarni yig&lsquo;ish va tartibga solish bo&lsquo;yicha amaliy ishlar bajarildi.</strong></p>",
      img: [
        { original: img7_1, thumbnail: img7_1 },
        { original: img7_2, thumbnail: img7_2 },
        { original: img7_3, thumbnail: img7_3 },
        { original: img7_4, thumbnail: img7_4 },
        { original: img7_5, thumbnail: img7_5 },
        { original: img7_6, thumbnail: img7_6 },
        { original: img7_7, thumbnail: img7_7 },
        { original: img7_8, thumbnail: img7_8 },
        { original: img7_9, thumbnail: img7_9 },
        { original: img7_10, thumbnail: img7_10 },
      ],
    },
    {
      title: "\u201cYURT OBODLIGI, AVVALO, MAHALLADAN BOSHLANADI!\u201d",
      text: "<p>\uD83D\uDD38 <strong>2026-yil 13\u201314-mart kunlari</strong> respublikaning barcha hududlarida <strong>&ldquo;Yurt obodligi, avvalo, mahalladan boshlanadi!&rdquo;</strong> shiori ostida <strong>umumxalq xayriya hashari</strong> o&lsquo;tkazilmoqda.<br><br>\uD83D\uDD38 TDTU <strong>Neft va gaz fakulteti professor-o'qituvchilar, tyutorlari va xodimlari hamda talaba-yoshlari</strong> tomonidan ham hashar tadbirlari tashkil etildi. Fakultet jamoasi <strong>atrof-muhitni obodonlashtirish, hududlarni tozalash, ko'chatlar ekish</strong> ishlarida faol ishtirok etishdi.</p>",
      img: [
        { original: img3_1, thumbnail: img3_1 },
        { original: img3_2, thumbnail: img3_2 },
        { original: img3_3, thumbnail: img3_3 },
        { original: img3_4, thumbnail: img3_4 },
        { original: img3_5, thumbnail: img3_5 },
        { original: img3_6, thumbnail: img3_6 },
        { original: img3_7, thumbnail: img3_7 },
        { original: img3_8, thumbnail: img3_8 },
        { original: img3_9, thumbnail: img3_9 },
      ],
    },
    {
      title: "\"Men ham ko\u2019chat ekaman\" aksiyasi \u2013 21-mart Navro\u2018z munosabati bilan",
      text: "<p>\uD83D\uDD38 Mazkur aksiya talaba-yoshlar o&lsquo;rtasida ekologik madaniyatni oshirish, atrof-muhitni asrashga bo&lsquo;lgan mas&rsquo;uliyat hissini kuchaytirish hamda yurtimizni yanada yashil hududga aylantirishga munosib hissa qo&lsquo;shish maqsadida o&lsquo;tkazildi.<br><br>\uD83D\uDD39 Aksiya jarayonida talaba-yoshlar faollik bilan ishtirok etib, har bir ekilgan ko&lsquo;chat kelajak avlod uchun muhim meros ekanini chuqur anglab yetdilar.<br><br>\uD83D\uDD39 <strong>&ldquo;Men ham ko&lsquo;chat ekaman&rdquo;</strong> aksiyasi yoshlarni tabiatni asrash, yurt obodligi yo&lsquo;lida fidokorona mehnat qilish hamda ekologik barqarorlikni ta&rsquo;minlashga chorlovchi muhim tashabbus sifatida alohida ahamiyat kasb etdi.</p>",
      img: [
        { original: img8_1, thumbnail: img8_1 },
        { original: img8_2, thumbnail: img8_2 },
        { original: img8_3, thumbnail: img8_3 },
        { original: img8_4, thumbnail: img8_4 },
        { original: img8_5, thumbnail: img8_5 },
        { original: img8_6, thumbnail: img8_6 },
        { original: img8_7, thumbnail: img8_7 },
        { original: img8_8, thumbnail: img8_8 },
        { original: img8_9, thumbnail: img8_9 },
      ],
    },
  ];

  return (
    <Layout>
      <CustomTitle name={"Yashil universitet"} />
      <PageWrapper>
        <div className="container">
          <CardGrid>

            {/* ── Featured video card ── */}
            <VideoCardWrapper>
              <iframe
                src="https://www.youtube.com/embed/5kwbqip4zYk"
                title="TDTUda Yashil makon loyihasi"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
              <CardBody>
                <div className="video-badge">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                    <polygon points="5 3 19 12 5 21 5 3" />
                  </svg>
                  Video
                </div>
                <CardTitle>
                  TDTUda &ldquo;Yashil makon&rdquo; umummilliy loyihasi doirasida ko&lsquo;chat ekish aksiyasi o&lsquo;tkazildi
                </CardTitle>
                <p style={{ fontSize: 13, color: '#6b7280', lineHeight: 1.6, margin: 0 }}>
                  Islom Karimov nomidagi TDTU da ekologik vaziyatni yaxshilash, yashil maydonlarni
                  kengaytirishga hissa qo&lsquo;shish maqsadida o&lsquo;tkazilgan aksiyadan video lavha.
                </p>
              </CardBody>
            </VideoCardWrapper>

            {/* ── Data cards ── */}
            {dateAllGreen.map((item, index) => (
              <GreenCard key={index} item={item} />
            ))}

          </CardGrid>
        </div>
      </PageWrapper>
    </Layout>
  );
}

export default GreenUniversitet;